<template>

  <b-col lg="12">
    <b-card-header v-if="!loading" style="border-bottom:0px !important; font-size:1.4em">
      <b style="color:#20a8d8">{{model}}</b> Failure Details <small style="margin-left:15px"> Total: {{total}} </small>
      <b-button class="download-button" variant="primary" size="xl" @click="downloadExcel();" >
        <div style="display:inline-block;" v-if="loading2019" class="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce bouncing2">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>Download
      </b-button>
      <b-form-group style="display:inline-block; float:right; margin-bottom:15px">
        <b-input-group size="xl">
          <b-form-input
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-card-header>
    <div v-if="loading" class="sk-double-bounce">
      <div class="sk-child sk-double-bounce1"></div>
      <div class="sk-child sk-double-bounce2"></div>
    </div>


    <b-table
      v-else
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      @filtered="onFiltered"
      :filter="filter"
      responsive="sm"
      :items="data"
      :fields="fields"
      style="background:#343b41; border:0px 1px solid black;"
    >
      <template v-slot:cell(failTracking)="data">
        <a v-bind:href="$trackerBase+'/tracker_private/includes/alphaReport.php?ftrack=' + data.item.fnsid">{{ data.item.failTracking }}</a>
      </template>
      <template v-slot:cell(user)="data">
        <img class="img-avatar table-img" size="xs" :src="data.item.user" >
      </template>
    </b-table>

  </b-col>

</template>

<script>

export default {
  name: "tables",
  props: ['part', 'model'],
  data: () => {
    return {
      excelDownload: "",
      loading2019: false,
      loadingExcel: false,
      productGroupParam: "",
      partParam: "",
      link: "all",
      filter: null,
      dateFrom: "",
      dateTo: "",
      modalDate: false,
      newharid: "",
      title: "",
      loading: false,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        {key: "failTracking", label: "FNSID-RA", sortable: true},
        {key: "productManufacturer", label: "Manufacturer", sortable: true},
        {key: "failDate", label: "Date"},
        {key: "user", label: "Technician"},
        {key: "failure_desc", label: "Failure", sortable: true},
        {key: "resolution_desc", label: "Resolution", sortable: true},
        {key: "refDes", label: "Component"},
        {key: "resBoard", label: "Board"},
        {key: "Complaint", label: "Complaint"},
        {key: "city", label: "Customer/City"},
      ]
    };
  },
  methods: {
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        xml: "true",
        fns_part: this.partParam
      };
      this.$http
        .get("api/alpha/products/getFailureDetails.php", {params, responseType: "blob"}).then(
        res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "TableReport.xlsx");
          document.body.appendChild(link);
          link.click();
          this.loading2019 = false;
        },
        err => {
          this.loading2019 = false;
          console.log(err);
        }
      );
    },
    fetchData() {
      this.loading = true;
      let params = {}
      params = {
        fns_part: this.partParam
      }
      this.$http.get("api/alpha/products/getFailureDetails.php", {params}).then(
        res => {
          if (res.data.message) {
            this.loading = false
          }
          this.total = res.data.length
          this.data = res.data;
          this.loading = false;
        },
        err => {
          this.loading = false;
          console.log(err);
        });
    },
    // updateHar(fnsid, har) {
    //     this.loading = true;
    //     let formData = new FormData();
    //     formData.append("fnsid", fnsid);
    //     formData.append("harid", har);
    //     this.$http.post( "api/har/tables/updateHar.php", formData, { headers: { "Content-Type": "multipart/form-data" } } ).then(
    //     res => {
    //         console.log(res.data);
    //         this.fetchData();
    //     },
    //     err => {
    //         this.newharid = "";
    //         console.log(err);
    //     }
    //     );
    // }
  },
  mounted() {
    this.dateFrom = this.$currentYear();

    this.dateTo = new Date().toJSON().slice(0, 10);
    this.partParam = this.part;
    this.fetchData();
  }
};
</script>
<style>
.table-img {
  height: 35px;
  display: block;
  margin: auto;
}

.complaintClass {
  width: 200px;
}

.download-button {
  display: inline-block;
  float: right;
  font-weight: 500;
  margin-left: 10px;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}

.bouncing2 {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}

.download-button:hover {
  text-decoration: none !important;
  color: white;
}

.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}

.gm-style .gm-style-iw-d {
  color: black !important;
}

.gm-style .gm-style-iw-d span {
  font-size: 1.1em;
}

.gm-style .gm-style-iw-d b {
  font-size: 1.1em;
}

.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}

.vdp-datepicker .input-group input {
  background: #515b65 !important;
}
</style>
